import React from 'react';
import cx from 'classnames';
import { List, ListItem } from '@xingternal/list';
import { Button } from '@xingternal/button';
import { usePopOver } from '@xingternal/pop-over';
import { IconArrowDown, IconArrowUp } from '@xingternal/icons';
import { Menu } from '@xingternal/menu';

import styles from './Dropdown.css';

type DropdownOptionProps = {
  children: React.ReactNode;
  skin?: string;
};

type DropdownListProps = {
  children: React.ReactNode;
};

type DropdownProps = {
  disabled?: boolean;
  children: React.ReactNode;
  isSelected?: boolean;
  label?: string;
  className?: string;
};

const DropdownOption = ({ children, skin }: DropdownOptionProps) => (
  <ListItem skin={{ listItem: skin }}>{children}</ListItem>
);

const DropdownList = ({ children }: DropdownListProps) => (
  <List skin={{ list: styles.list }}>{children}</List>
);
const Dropdown = ({
  children,
  disabled,
  label,
  className,
  isSelected,
}: DropdownProps) => {
  const popOver = usePopOver();

  return (
    <div className={className}>
      <Button
        icon={popOver.show ? IconArrowUp : IconArrowDown}
        size={'small'}
        variant={'tertiary'}
        onClick={popOver.show ? popOver.handleHide : popOver.handleShow}
        innerRef={popOver.triggerRef}
        disabled={disabled}
        className={cx({ [styles.active]: popOver.show || isSelected })}
      >
        {label}
      </Button>
      <Menu
        onOutsideClick={popOver.handleHide}
        triggerRef={popOver.triggerRef}
        show={popOver.show}
      >
        {children}
      </Menu>
    </div>
  );
};

export { Dropdown, DropdownOption, DropdownList };
